<template>
<div class="safe-setting-view">
        <div v-for="(scope, index) in scopeTitleList">
            <div class="safe-setting-item">
                <div class="title">{{ scope.title }}</div>
                <div class="scope-list" v-for="(item, idx) in scope.items" :key="idx">
                    <div class="scope-item" @click="changeScope(index, item)">
                        <div class="select-icon" :class="{ 'selected': currentSelected(index, item) }"></div>
                        <div class="scope-item-name">{{ item.desc }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import { mapState } from "vuex";
import { SAFE_CREATE_LIST, SAFE_DELETE_LIST, SAFE_WIKI_PAGE_URL_AUTH_UPDATE_LIST, SAFE_MODE_LIST } from '../../constants/SettingSpace';
import { querySpaceSetting, saveSpaceSetting } from '../../core/api/setting';
import { getKBInfo } from '../../core/api/file';
import { store } from '../../store/store';

export default {
  name: 'SafeSettingView',
  data() {
    return {
      scopeTitleList: [
      { title: intl.$t("谁可以新建知识库的一级页面？"), items: SAFE_CREATE_LIST },
      { title: intl.$t("谁可以删除知识库中的子页面？"), items: SAFE_DELETE_LIST },
      { title: intl.$t("谁可以修改文档的链接分享范围？"), items: SAFE_WIKI_PAGE_URL_AUTH_UPDATE_LIST }
      // { title: '有编辑权限的用户查看页面时，页面的默认模式？', items: SAFE_MODE_LIST }
      ],
      currentCreateSetting: '',
      currentDeleteSetting: '',
      currentAuthUpdateSetting: '',
      currentModeSetting: '' };

  },
  computed: {
    ...mapState({
      wikiSpaceInfo: (state) => state.kbTreeNodeModule.wikiSpaceInfo }),

    currentWikiSpaceId() {
      let wikiSpaceId: string = this.wikiSpaceInfo.wikiSpaceId;
      return wikiSpaceId;
    } },

  methods: {
    querySpaceSettings() {
      querySpaceSetting(this.currentWikiSpaceId).then((res: any) => {
        const { code, data, message } = res.data;
        if (code === 200) {
          data.forEach((item: any) => {
            if (item.settingsCode === "FILE.WIKI_SPACE.WIKI_FIRST_PAGE_CREATE") {
              this.currentCreateSetting = item.settingsValue;
            } else if (item.settingsCode === "FILE.WIKI_SPACE.WIKI_PAGE_DELETE") {
              this.currentDeleteSetting = item.settingsValue;
            } else if (item.settingsCode === "FILE.WIKI_SPACE.WIKI_PAGE_URL_AUTH_UPDATE") {
              this.currentAuthUpdateSetting = item.settingsValue;
            } else {
              this.currentModeSetting = item.settingsValue;
            }
          });
        } else {
          this.$message.error(intl.$t("查询空间设置失败，"), message);
        }
      }).catch((err) => {
        this.$message.error(intl.$t("查询空间设置失败，请刷新重试"));
      });
    },
    changeScope(index: number, item: any) {
      if (
      index === 0 && this.currentCreateSetting === item.name ||
      index === 1 && this.currentDeleteSetting === item.name ||
      index === 2 && this.currentAuthUpdateSetting === item.name ||
      index === 3 && this.currentModeSetting === item.name) {
        return;
      }
      this.changeSpaceSetting(index, item);
    },
    changeSpaceSetting(index: number, item: any) {
      let changeSettingsCode = '';
      switch (index) {
        case 0:
          changeSettingsCode = "FILE.WIKI_SPACE.WIKI_FIRST_PAGE_CREATE";
          break;
        case 1:
          changeSettingsCode = "FILE.WIKI_SPACE.WIKI_PAGE_DELETE";
          break;
        case 2:
          changeSettingsCode = "FILE.WIKI_SPACE.WIKI_PAGE_URL_AUTH_UPDATE";
          break;
        case 3:
          changeSettingsCode = "FILE.PAGE_READ_MODE";
          break;
        default:
          break;}

      let settingList: any[] = [{
        settingsCode: changeSettingsCode,
        settingsValue: item.name }];

      saveSpaceSetting(this.currentWikiSpaceId, settingList).then((res: any) => {
        const { code, message } = res.data;
        if (code === 200) {
          if (index === 0) {
            this.currentCreateSetting = item.name;
          } else if (index === 1) {
            this.currentDeleteSetting = item.name;
          } else if (index === 2) {
            this.currentAuthUpdateSetting = item.name;
          } else {
            this.currentModeSetting = item.name;
          }
          this.$message.success(intl.$t("设置成功"));
          // 从新请求知识库配置信息
          const paramsURL = new URL(location.href).searchParams;
          const paramFid = paramsURL.get('fid');
          getKBInfo(paramFid).then((res: any) => {
            const { code, data, message } = res.data;
            if (code === 200) {
              store.dispatch('kbModule/setWikiSpaceInfo', data.wikiSpaceInfo);
            }
          });
        } else {
          this.$message.error(intl.$t("空间设置失败，"), message);
        }
      }).catch((err) => {
        this.$message.error(intl.$t("空间设置失败，请重试"));
      });
    },
    currentSelected(index: number, item: any) {
      if (index === 0) {
        return this.currentCreateSetting === item.name;
      } else if (index === 1) {
        return this.currentDeleteSetting === item.name;
      } else if (index === 2) {
        return this.currentAuthUpdateSetting === item.name;
      } else {
        return this.currentModeSetting === item.name;
      }
    } },


  created() {
    this.querySpaceSettings();
  } };
</script>

<style lang="scss" scoped>
.safe-setting-view {
    height: calc(100% - 94px);

    .safe-setting-item {
        margin: 40px 24px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: nowrap;

        .title {
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #121317;
            line-height: 20px;
        }

        .scope-list {
            .scope-item {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin-top: 16px;
                cursor: pointer;

                &:hover > .select-icon {
                    background-image: url(@/assets/img/setting/icon_setting_selected_hover.svg);
                }

                .select-icon {
                    width: 16px;
                    height: 16px;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                    background-image: url(@/assets/img/setting/icon_setting_unselected.svg);

                    &.selected {
                        background-image: url(@/assets/img/setting/icon_setting_selected.svg);
                    }
                }

                

                .scope-item-name {
                    margin-left: 8px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #222329;
                    line-height: 6px;
                }
            }
        }
    }

}
</style>
